import { all } from 'redux-saga/effects';

import {
  auth,
  businessCategories,
  businessInfo,
  businessReferralProgram,
  couponBuilder,
  coupons,
  customerCoupons,
  dashboards,
  locations,
  memberships,
  passwords,
  pointsBalance,
  referralCodes,
  signup,
  taxRates,
  usedCoupons,
  couponImages,
  sendNotification,
  followers,
  pointsRequests,
  admin,
  affiliateBusiness,
  rakuten,
  awin,
  payment,
  couponWizard,
  aiContent,
  cj,
  stats,
  impact,
  customerFirebaseAuth,
  businesses,
  customerProfile,
  cities,
  referrals,
  customerPreferences,
  couponRangeList,
  products,
  email
} from './modules';

export default function* saga() {
  yield all([
    referralCodes.saga(),
    auth.saga(),
    signup.saga(),
    locations.saga(),
    businessCategories.saga(),
    businessReferralProgram.saga(),
    couponBuilder.saga(),
    businessInfo.saga(),
    passwords.saga(),
    pointsBalance.saga(),
    dashboards.saga(),
    coupons.saga(),
    customerCoupons.saga(),
    memberships.saga(),
    taxRates.saga(),
    usedCoupons.saga(),
    couponImages.saga(),
    sendNotification.saga(),
    followers.saga(),
    pointsRequests.saga(),
    admin.saga(),
    affiliateBusiness.saga(),
    rakuten.saga(),
    awin.saga(),
    payment.saga(),
    couponWizard.saga(),
    aiContent.saga(),
    cj.saga(),
    stats.saga(),
    impact.saga(),
    customerFirebaseAuth.saga(),
    businesses.saga(),
    customerProfile.saga(),
    cities.saga(),
    referrals.saga(),
    customerPreferences.saga(),
    couponRangeList.saga(),
    products.saga(),
    email.saga(),
  ]);
}
